import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";

export default function UpgradeActOneTimeProfit() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [activamount, setActivation] = useState("");
  const [name, setName] = useState("");

  const [utr, setUtr] = useState("");
  const [usd, setUsd] = useState(0);
  const [isLoading, setisLoading] = useState(false);

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /^[A-Za-z]*\d+[A-Za-z]/g,
      "",
    );
    const limitedValue = sanitizedValue.slice(0, 10);

    setSearch(limitedValue);
    CheckUserId_Api(limitedValue);
  };

  const CheckUserId_Api = async (value) => {
    try {
      let res = await API.post(
        "/CheckUserId",
        {
          loginid: userId,
          uid: value.slice(2),
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("cuser_Api", res.data);
      if (res?.data?.data === "WrongId") {
        setName("Wrong Id");
      } else {
        setSearch(value);
        setName(res?.data?.data);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleAmount = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      "",
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setActivation(limitedValue);
    setUsd(limitedValue);
  };

  const referral_API = async () => {
    try {
      let confirm = window.confirm("Are you sure, you want to Upgarde?");
      if (!confirm) {
        return;
      }
      setisLoading(true);
      if (!search) {
        toast.error("Enter Id");
        return;
      }
      if (!usd) {
        toast.error("Enter Amount");
        return;
      }
      let responceRight = await API?.post(
        "/Act_OneTimeProfitSubcription",
        {
          loginid: userId,
          uid: search.slice(2),
          type: "FUNDS",
          amount: usd,
          referby: "Admin",
          // amounttoken:usd,
          // txn:"Admin Activate"
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      console.log("My_Team", responceRight.data);
      if (responceRight.data.data.RESULT === "Successful Staking !!") {
        toast.success(responceRight.data.data.RESULT);
        setActivation("");
        setSearch("");
        setName("");
        setUsd("");
      } else {
        toast.error(responceRight.data.data.RESULT);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">One Time Profit Subcription</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1>One Time Profit Subcription</h1>
                                  <Link
                                    to="/ActivationhistoryPlanB"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                    }}
                                  >
                                    One Time Profit Subcription History
                                  </Link>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    // inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter User Id"
                                    value={search}
                                    onChange={handleChange}
                                  />
                                  {/* {name && <p>{name}</p>} */}
                                  {name && (
                                    <p
                                      className={
                                        name === "Wrong Id"
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {name}
                                    </p>
                                  )}
                                </div>

                                <div class="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    value={activamount}
                                    onChange={handleAmount}
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Txn</label>
                                  <input
                                    type="text"
                                    maxLength={20}
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Remark"
                                    value={utr}
                                    onChange={(e) => setUtr(e.target.value)}
                                  />
                                </div> */}
                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    className="btn"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => referral_API()}
                                    disabled={isLoading}
                                  >
                                    Upgrade{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
